module.exports = __webpack_public_path__ + "media/components/country-flag/static/lv-1044c688c5112f696893dfeeb366f939.svg";